/* AmourLinen bedding PDP behaviour (dropdowns, country sheet, price, add to cart). Moved out of
snippets/kd-pdp-bedding.liquid in Oct 2026; helpers live in assets/kd-pdp-bedding-sizes.js. */
(function () {
  var A = window.ALB;
  if (!A) return;
  var NAMES = A.NAMES, CHEVRON = A.CHEVRON, esc = A.esc, parseProbe = A.parseProbe, makeMoney = A.makeMoney, storedCountry = A.storedCountry;

  function boot(root) {
    if (root.__alb) return;
    root.__alb = true;
    document.body.classList.add('alp-on');

    var data;
    try { data = JSON.parse(root.querySelector('[data-alb-data]').textContent); } catch (e) { return; }
    var money = makeMoney(parseProbe(data.probe));
    var cc = storedCountry(data.cc);
    var comps = data.comps || [];
    var isSet = data.mode === 'set';
    var hasCards = isSet || data.mode === 'pair';
    var sel = {};
    var showAll = {};
    var complete = false;

    var fieldsBox = root.querySelector('[data-alb-fields]');
    var priceEl = root.querySelector('[data-alb-price]');
    var wasEl = root.querySelector('[data-alb-was]');
    var badgeEl = root.querySelector('[data-alb-badge]');
    var atc = root.querySelector('[data-alb-atc]');
    var atcLabel = root.querySelector('[data-alb-atc-label]');
    var errEl = root.querySelector('[data-alb-error]');
    var mtoEl = root.querySelector('[data-alb-mto]');
    var setBox = root.querySelector('[data-alb-set]');
    var countryEl = root.querySelector('[data-alb-country]');
    var sheet = root.querySelector('[data-alb-sheet]');
    var changeBtn = root.querySelector('[data-alb-change]');

    function comp(key) { for (var n = 0; n < comps.length; n++) if (comps[n].key === key) return comps[n]; return null; }

    /* size names and measurements: see assets/kd-pdp-bedding-sizes.js */
    function allMode() { return A.allMode(cc); }
    function partsOf(v, expanded) { return A.partsOf(v, cc, expanded); }
    function labelOf(v, expanded) { return partsOf(v, expanded).name; }
    var areaOf = A.areaOf;
    function isLocal(v) { return A.isLocal(v, cc); }
    function visible(c) {
      var list = c.variants;
      if (showAll[c.key]) return list;
      var out = list.filter(function (v) { return isLocal(v) || v === sel[c.key]; });
      return out.length ? out : list;
    }
    function pickDefault(c) {
      var vis = visible(c);
      var prefer = c.key === 'duvet' || c.key === 'main' ? data.defaultName : (c.key === 'pillow' ? 'Standard' : '');
      var pick = null;
      if (prefer) vis.forEach(function (v) { if (!pick && v.n === prefer && v.ok) pick = v; });
      if (!pick) vis.forEach(function (v) { if (!pick && v.ok) pick = v; });
      return pick || vis[0];
    }

    /* ---------- build the dropdown fields ---------- */
    function buildFields() {
      var html = '';
      comps.forEach(function (c) {
        var isFitted = c.key === 'fitted';
        html += '<div class="alb-field" data-alb-field="' + c.key + '"' + (isFitted ? ' hidden' : '') + '>' +
          '<div class="alb-field__head"><span class="alb-field__label">' + esc(c.title) + '</span>' +
          (isFitted ? '<span class="alb-field__badge" data-alb-fbadge hidden></span><button type="button" class="alb-remove" data-alb-remove>Remove</button>' : '') +
          '</div>' +
          '<div class="alb-dd" data-alb-dd>' +
          '<button type="button" class="alb-dd__btn" aria-haspopup="listbox" aria-expanded="false"><span data-alb-val></span>' + CHEVRON + '</button>' +
          '<ul class="alb-dd__list" role="listbox" hidden></ul></div></div>';
      });
      fieldsBox.innerHTML = html;
    }

    function renderList(c) {
      var f = fieldsBox.querySelector('[data-alb-field="' + c.key + '"]');
      if (!f) return;
      var expanded = !!showAll[c.key];
      var vis = visible(c);
      function row(v) {
        var i = c.variants.indexOf(v), on = v === sel[c.key];
        var pt = partsOf(v, expanded);
        var dims = pt.dims.length ? '<span class="alb-dd__dims">' + pt.dims.map(function (d, n) { return '<span' + (n ? ' class="alb-dd__dim2"' : '') + '>' + esc(d) + '</span>'; }).join('') + '</span>' : '';
        return '<li role="option" class="alb-dd__opt' + (on ? ' is-on' : '') + (v.ok ? '' : ' is-off') + '" data-i="' + i + '" aria-selected="' + on + '"' + (v.ok ? '' : ' aria-disabled="true"') + ' tabindex="-1"><span class="alb-dd__name">' + esc(pt.name) + '</span>' + dims + '</li>';
      }
      var html;
      if (expanded && !allMode()) {
        /* this country's sizes first, then every other size, smallest to largest */
        var mine = c.variants.filter(isLocal);
        var others = c.variants.filter(function (v) { return !isLocal(v); }).sort(function (a, b) { return areaOf(a) - areaOf(b); });
        html = mine.map(row).join('');
        if (others.length) html += '<li role="presentation" class="alb-dd__group">Other sizes</li>' + others.map(row).join('');
      } else {
        html = vis.map(row).join('');
        if (vis.length < c.variants.length) html += '<li role="option" class="alb-dd__all" data-all="1" tabindex="-1">Show all sizes</li>';
      }
      f.querySelector('.alb-dd__list').innerHTML = html;
      f.querySelector('[data-alb-val]').textContent = sel[c.key] ? labelOf(sel[c.key], expanded) : '';
    }

    function closeAll() {
      [].slice.call(fieldsBox.querySelectorAll('[data-alb-dd]')).forEach(function (dd) {
        dd.classList.remove('is-open');
        dd.querySelector('.alb-dd__list').hidden = true;
        dd.querySelector('.alb-dd__btn').setAttribute('aria-expanded', 'false');
      });
    }
    function openDd(dd) {
      closeAll();
      dd.classList.add('is-open');
      dd.querySelector('.alb-dd__list').hidden = false;
      dd.querySelector('.alb-dd__btn').setAttribute('aria-expanded', 'true');
    }

    /* ---------- totals, labels, button ---------- */
    function activeComps() { return comps.filter(function (c) { return c.key !== 'fitted' || complete; }); }

    function refresh() {
      var now = 0, was = 0, ok = true, mto = false;
      activeComps().forEach(function (c) {
        var v = sel[c.key];
        if (!v) { ok = false; return; }
        now += v.p * c.qty;
        was += (v.w > v.p ? v.w : v.p) * c.qty;
        if (!v.ok) ok = false;
        if (v.e && v.e.mto) mto = true;
      });
      if (priceEl) priceEl.textContent = money(now);
      var hasWas = was > now;
      if (wasEl) { wasEl.textContent = money(was); wasEl.hidden = !hasWas; }
      if (badgeEl) { badgeEl.textContent = hasWas ? '-' + Math.round((was - now) * 100 / was) + '%' : ''; badgeEl.hidden = !hasWas; }
      if (atc) {
        atc.disabled = !ok;
        atcLabel.textContent = ok ? ('Add to Cart • ' + money(now)) : 'Out of stock';
      }
      if (mtoEl) { mtoEl.hidden = !mto; }
      var f = comp('fitted');
      var sub = root.querySelector('[data-alb-complete-sub]');
      if (f && sub && sel.fitted) sub.textContent = '+ ' + (f.sub || f.title) + ' ' + money(sel.fitted.p);
      comps.forEach(renderList);
      if (countryEl) countryEl.textContent = NAMES[cc] || data.country || cc;
    }

    function setComplete(on) {
      complete = on;
      [].slice.call(root.querySelectorAll('[data-alb-card]')).forEach(function (b) {
        var is = (b.getAttribute('data-alb-card') === 'complete') === on;
        b.classList.toggle('is-on', is);
        b.setAttribute('aria-checked', is ? 'true' : 'false');
      });
      var ff = fieldsBox.querySelector('[data-alb-field="fitted"]');
      if (ff) ff.hidden = !on;
      closeAll();
      refresh();
    }

    /* ---------- init ---------- */
    buildFields();
    comps.forEach(function (c) { sel[c.key] = pickDefault(c); });

    var fittedComp = comp('fitted');
    if (hasCards && setBox) {
      if (fittedComp) {
        setBox.hidden = false;
        if (data.completeBadge) {
          var cb = root.querySelector('[data-alb-card-badge]');
          var fb = root.querySelector('[data-alb-fbadge]');
          if (cb) { cb.textContent = data.completeBadge; cb.hidden = false; }
          if (fb) { fb.textContent = data.completeBadge; fb.hidden = false; }
        }
      }
    }
    refresh();

    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      var card = t.closest ? t.closest('[data-alb-card]') : null;
      if (card && root.contains(card)) { setComplete(card.getAttribute('data-alb-card') === 'complete'); return; }

      var rm = t.closest ? t.closest('[data-alb-remove]') : null;
      if (rm && root.contains(rm)) { setComplete(false); return; }

      var btn = t.closest ? t.closest('.alb-dd__btn') : null;
      if (btn && fieldsBox.contains(btn)) {
        var dd = btn.parentNode;
        if (dd.classList.contains('is-open')) closeAll(); else openDd(dd);
        return;
      }

      var li = t.closest ? t.closest('.alb-dd__opt, .alb-dd__all') : null;
      if (li && fieldsBox.contains(li)) {
        var field = li.closest('[data-alb-field]');
        var c = comp(field.getAttribute('data-alb-field'));
        if (li.getAttribute('data-all')) { showAll[c.key] = true; renderList(c); return; }
        var v = c.variants[parseInt(li.getAttribute('data-i'), 10)];
        if (!v || !v.ok) return;
        sel[c.key] = v;
        closeAll();
        refresh();
        return;
      }

      if (!(t.closest && t.closest('[data-alb-dd]'))) closeAll();
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); if (sheet && !sheet.hidden) { sheet.hidden = true; if (changeBtn) changeBtn.setAttribute('aria-expanded', 'false'); } return; }
      var li = e.target.closest ? e.target.closest('.alb-dd__opt, .alb-dd__all') : null;
      var btn = e.target.closest ? e.target.closest('.alb-dd__btn') : null;
      if (e.key === 'Enter' || e.key === ' ') { if (li) { e.preventDefault(); li.click(); } return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var dd = (li || btn) ? (li || btn).closest('[data-alb-dd]') : null;
        if (!dd) return;
        e.preventDefault();
        if (!dd.classList.contains('is-open')) openDd(dd);
        var items = [].slice.call(dd.querySelectorAll('.alb-dd__opt, .alb-dd__all'));
        var at = items.indexOf(li);
        var next = e.key === 'ArrowDown' ? items[at + 1] || items[0] : items[at - 1] || items[items.length - 1];
        if (next) next.focus();
      }
    });

    /* country sheet */
    if (changeBtn && sheet) {
      changeBtn.addEventListener('click', function () { sheet.hidden = false; changeBtn.setAttribute('aria-expanded', 'true'); });
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet) { sheet.hidden = true; changeBtn.setAttribute('aria-expanded', 'false'); return; }
        var b = e.target.closest ? e.target.closest('.alb-sheet__country') : null;
        if (!b) return;
        cc = b.getAttribute('data-code');
        try { localStorage.setItem('al_size_country', cc); } catch (err) {}
        showAll = {};
        comps.forEach(function (c) { if (!visible(c).indexOf || visible(c).indexOf(sel[c.key]) === -1) sel[c.key] = pickDefault(c); });
        sheet.hidden = true;
        changeBtn.setAttribute('aria-expanded', 'false');
        refresh();
      });
      [].slice.call(sheet.querySelectorAll('.alb-sheet__country')).forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-code') === cc);
      });
    }

    /* Size Guide: reuse the theme's own opener, same as the pyjamas PDP */
    var sg = root.querySelector('[data-alb-sizeguide]');
    if (sg) sg.addEventListener('click', function () {
      var sels = ['[data-size-chart-open]', '[data-size-guide-open]'];
      for (var s = 0; s < sels.length; s++) { var el = document.querySelector(sels[s]); if (el) { el.click(); return; } }
      var all = document.querySelectorAll('.product-popup button, .product-popup summary, .product-popup a');
      for (var n = 0; n < all.length; n++) { if ((all[n].textContent || '').trim().toLowerCase().indexOf('size guide') === 0) { all[n].click(); return; } }
      window.location.href = '/pages/size-guide';
    });

    /* ---------- add to cart: each component as its own line ---------- */
    var form = root.querySelector('[data-alb-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled || atc.classList.contains('is-busy')) return;
      var items = [];
      activeComps().forEach(function (c) {
        var v = sel[c.key];
        var it = { id: v.id, quantity: c.qty };
        if (isSet) it.properties = { _set: data.setKey };
        items.push(it);
      });
      errEl.hidden = true;
      atc.classList.add('is-busy');
      var before = atcLabel.textContent;
      atcLabel.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart');
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.refreshDrawer === 'function') {
            return drawer.refreshDrawer().then(function () { drawer.open(); });
          }
          window.location.href = '/cart';
        })
        .catch(function (err) {
          errEl.textContent = String(err && err.message || err);
          errEl.hidden = false;
        })
        .then(function () {
          atc.classList.remove('is-busy');
          refresh();
          if (atcLabel.textContent === 'Adding...') atcLabel.textContent = before;
        });
    });
  }

  function init() { [].slice.call(document.querySelectorAll('[data-alb]')).forEach(boot); }
  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();